import {env} from 'mutants-microfx';
const {constant, platform} = env;

const platform_browser = platform === constant.platform.browser;

export {platform_browser}
